import { GatsbyLink, GatsbyLinkProps } from "@mgdx-libs/link";
import { cx } from "cva";
import { Fragment } from "react";

import { Badge } from "../Badge";
import { applyIconColor, IconButtonLinkBaseProps, variants } from ".";
import styles from "./index.module.css";
export const IconButtonLink = ({
  className,
  disabled,
  children,
  variant = "solid",
  color,
  size,
  to,
  number,
  text,
  shadow,
  onClick,
  ...props
}: IconButtonLinkBaseProps & Omit<GatsbyLinkProps<Record<never, never>>, "ref">) => {
  const badgeVariant = variant === "solid" ? "lighted" : "solid";
  const badgeColor = variant !== "solid" && color === "key" ? "primary" : undefined;

  const coloredIcon = applyIconColor({ icon: children, variant, color });

  return (
    <GatsbyLink
      to={to}
      aria-disabled={disabled}
      className={cx(styles.button, className)}
      tabIndex={disabled ? -1 : undefined}
      onClick={disabled ? (event) => event.preventDefault() : onClick}
      {...props}
    >
      <span className={variants({ variant, color, size, shadow })}>
        {coloredIcon}
        {!!number && (
          <Badge number={number} variant={badgeVariant} color={badgeColor} size="s" className={styles.badge} />
        )}
      </span>
      {!!text && (
        <p className={styles.text}>
          {text.split(/<br\s*\/?>/i).map((line, index) => (
            <Fragment key={index}>
              {line}
              <br />
            </Fragment>
          ))}
        </p>
      )}
    </GatsbyLink>
  );
};
